import React, { useState } from "react";
import ModalVideo from "react-modal-video";
import "react-modal-video/css/modal-video.css";

function AboutWrapperArea() {
  const [isOpen, setOpen] = useState(false);

  return (
    <>
      <div className="about-main-wrappper pt-110">
        <div className="container">
          <div className="about-tab-wrapper">

            <div className="row justify-content-center">
              <div className="col-lg-4">
                <div className="about-tab-image-grid text-center">
                  <div className="row float-images g-4">
                    <div className="col-lg-12 col-md-6 col-sm-6">
                      <div className="about-image">
                        <img src={process.env.PUBLIC_URL + "/images/about-1.png"} alt="Mountains at CAMP" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-8 mt-5 mt-lg-0">
                <div className="about-tab-wrap">
                  <h2 className="about-wrap-title">
                    <span className="txt-gradient-1">About CAMP</span>
                  </h2>
                  <div className="about-section has-bg-image">
                    <p>Nestled in the French pyrenees at 750m altitude, 10km from the Spanish border and surrounded by snowcapped peaks, waterfalls and forests, is the picturesque thermal village of Aulus-les-bains. In the village, housed in a beautifully renovated 19th century hotel, is CAMP - the first of a new breed of arts residency. CAMP runs five-day arts, music, writing and arts-activist sessions. These are no ordinary workshops - they are intense, artistic catalysts run by internationally acclaimed practitioners; creative flashpoints designed to change the lives of everyone involved. The workshops combine work in our well equipped facilities with projects carried out in the mountains - check out the workshops for full details.</p>

                    <p>CAMP houses advanced facilities available to all residential students - recording facilities, digital video and photography editing suites, rehearsal and performance spaces, fine art studios, projection facilities, multichannel listening environments, VR studio, and an arts library. Accommodation is provided at the centre in peaceful, private rooms, and excellent catering is included.</p>

                    <p>It's a place where great art is made, new movements are formed, new ideas are explored and groundbreaking people are nurtured. It's about generating revolutions, incubating creative minds and bringing the best emerging practitioners in all artistic fields to their full potential.</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="row justify-content-center">
              <div className="col-lg-8 mt-5 mt-lg-0">
                <div className="about-tab-wrap">
                  <h2 className="about-wrap-title">
                    <span className="txt-gradient-2">Accommodation & catering</span>
                  </h2>
                  <div className="about-section has-bg-image">
                    <p>
                      We have 15 private, peaceful rooms at CAMP, each with mountain views and work facilities. Double and twin rooms are available on request. All the rooms are fully equipped and comfortable - no need to bring towels, linen, etc - everything is provided.</p>
                    <p>
                      Our mountain region is celebrated for its cuisine - local specialities include a huge variety of cheeses, charcuterie, preserves, mushrooms and other delicacies. Breakfast, lunch and dinner are prepared every day at CAMP - we can cater for all diets, and there's always plenty of wine, cheese and snacks flowing! A few things previous attendees have said about the food at CAMP:</p>

                    <div className="container foodq">
                      <div className="row foodq align-items-start">
                        <div className="col-sm food-quote">
                        <i className="fa-solid fa-bowl-food fa-2xl"></i><p><i>So tasty and delicious, lots of new recipes to take home and try and also a check in about how badly I was eating prior!</i></p>
                        </div>
                        <div className="col-sm food-quote">
                        <i className="fa-solid fa-wine-glass fa-2xl"></i><p><i>Banging. Delicious food, plenty of it and lots of wine too, which is nice!</i></p>
                        </div>
                        <div className="col-sm food-quote">
                        <i className="fa-solid fa-cheese fa-2xl"></i><p><i>As a vegetarian, it was awesome. Fresh and delicious food cooked by the lovely staff everyday. Cherry on top: fresh croissants, beers and cheese everyday <i className="fa-solid fa-heart"></i> You guys rock!</i></p>
                        </div>
                        <div className="col-sm food-quote">
                        <i className="fa-solid fa-pizza-slice fa-2xl"></i><p><i>Honestly one of the highlights. Utterly delicious.</i></p>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="about-tab-image-grid text-center">
                  <div className="row float-images g-4">
                    <div className="col-lg-12 col-md-6 col-sm-6">
                      <div className="about-image">
                        <img src={process.env.PUBLIC_URL + "/images/about-2.png"} alt="CAMP accommodation" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row justify-content-center">
              <div className="col-lg-4">
                <div className="about-tab-image-grid text-center">
                  <div className="row float-images g-4">
                    <div className="col-lg-12 col-md-6 col-sm-6">
                      <div className="about-image">
                        <img src={process.env.PUBLIC_URL + "/images/about-3.png"} alt="CAMP facilities" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-8 mt-5 mt-lg-0">
                <div className="about-tab-wrap">
                  <h2 className="about-wrap-title">
                    <span className="txt-gradient-3">Facilities</span>
                  </h2>
                  <div className="about-section has-bg-image">
                    <p>
                      Our facilities are available to all participants, enabling the production of professional standard work throughout your stay. Alongside our fixed facilities we have a modular bank of audio, video, high tech and fine art equipment which can be set up in any of CAMP's many workspaces. CAMP participants enjoy selecting a workspace, choosing equipment, and building a unique, tailored project space for their work with the help of our team.
                    </p>
                    <p>
                      We have indoor and outdoor work and performance spaces, sound systems, projectors, music production gear (interfaces, speakers, mics, controllers), computers, acoustic and electronic instruments, a beautiful Yamaha U10 piano, drum kit, loads of AV equipment, VR gear, field recording equipment (recorders, mics, etc), art/making equipment (glue guns, soldering irons, hand-tools, etc), and a lot more.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="row justify-content-center">
              <div className="col-lg-8 mt-5 mt-lg-0">
                <div className="about-tab-wrap">
                  <h2 className="about-wrap-title">
                    <span className="txt-gradient-4">Transport</span>
                  </h2>
                  <div className="about-section has-bg-image">
                    <p>The first step in getting to CAMP is to get to Toulouse. By air: Toulouse (TLS) is extremely well served by international routes. By rail: highly recommended, the train network in France is fast, comfortable, reliable and relatively cheap. Get your ticket from <a href="http://www.voyages-sncf.com" target="_blank" rel="noopener noreferrer">http://www.voyages-sncf.com</a> and head for Toulouse Matabiau. By bus: maybe the cheapest option if you're booking last minute, check <a href="http://www.ouibus.com" target="_blank" rel="noopener noreferrer">http://www.ouibus.com</a>.</p>

                    <p>We provide a return shuttle service from Toulouse to CAMP - this is included in the price of your session. For onsite workshops, the minibus leaves Toulouse Matabiau train station at 18:00 on the Tuesday before your course starts, and will get you back to Toulouse by 11:00 on the Monday after it finishes. For self-guided residencies, the minibus leaves Toulouse Matabiau train station at 13:00 on Wednesday, and will get you back to Toulouse by 11:00 the following Wednesday. In both cases, all accommodation and meals are provided for the full period.</p>

                    <p>In case, for some reason, you don't want to get in the minibus - other options for the Toulouse to CAMP journey include car share/hire (you can discuss this with your fellow participants via our forums after signup), or public transport. The latter is tricky, but not impossible - you'll need to set off fairly early from Toulouse to make the trip in one day. For detailed info on public transport, check the <a href="/faq">FAQ</a>.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="about-tab-image-grid text-center">
                  <div className="row float-images g-4">
                    <div className="col-lg-12 col-md-6 col-sm-6">
                      <div className="about-image">
                        <img src={process.env.PUBLIC_URL + "/images/about-4.png"} alt="Transport to CAMP" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div >
    </>
  );
}

export default AboutWrapperArea;
